{
  "decrease": "{fieldLabel} verringern",
  "increase": "{fieldLabel} erhöhen",
  "numberField": "Nummernfeld"
}
